//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

import { makeStyles } from "@material-ui/core/styles";

export const styles = makeStyles((theme) => ({
  searchInput: {
    width: 400,
    borderRadius: 20,
    "@media (max-width: 600px)": {
      width: "100%",
    },
  },
  dateInput: {
    width: "100%",
  },
  searchInputIcon: {
    cursor: "pointer",
  },
  topGrid: {    
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  exportBtn1: {
    color: "#fff",
    width: "120px",
    height: "35px",
    fontSize: "14px",
    cursor: "pointer",
    fontFamily: "segoe-ui",
    borderRadius: 5,
    backgroundColor: "#0a72ba",
    border: "none",
    // marginLeft:"38%",

    "@media (max-width: 600px)": {
      marginTop: "4rem",
    },
  },
   root: {
    flexGrow: 1,
    marginBottom: 20,
  },
  tableDownInResponsive: {
    marginBottom: 150,
  },
  createBtn: {
    float: "right",
  },
  link: {
    color: "blue",
    textDecoration: "underline",
    cursor: "pointer",
  },
  // Create
  dateInput: {
    width: "100%",
  },
  submitBtn: {
    color: "#fff",
    backgroundColor: "#305698 !important",
    fontSize: 15,
    border: " 1px solid #2F7CBD",
    borderRadius: 10,
    textTransform: "capitalize",
    width: 100,
    "&:hover": {
      backgroundColor: "#305698 !important",
    },
  },
  // View
  label: {
    verticalAlign: "-webkit-baseline-middle",
  },
  editInput: {
    width: "80%",
  },
  cancelBtn: {
    color: "#305698",
    backgroundColor: "#fff !important",
    fontSize: 15,
    border: "1px solid #2F7CBD",
    borderRadius: 10,
    textTransform: "capitalize",
    width: 100,
    "&:hover": {
      backgroundColor: "#fff !important",
    },
  },
  // Dialog
  dialogParentDiv: {
    padding: 25,
  },
  parentText: {
    fontSize: 25,
  },
  createBtn1: {
    float: "right",
  },
  createBtn: {
    color: "#fff",
    width: "120px",
    height: "35px",
    fontSize: "14px",
    cursor: "pointer",
    fontFamily: "segoe-ui",
    borderRadius: 5,
    backgroundColor: "#0a72ba",
    border: "none",
    // marginLeft:"38%",

    "@media (max-width: 600px)": {
      marginTop: "4rem",
    },
  },
 uploadBtn: {
  color: "#fff",
  width: "120px",
  height: "35px",
  fontSize: "14px",
  cursor: "pointer",
  fontFamily: "segoe-ui",
  borderRadius: 5,
  backgroundColor: "#0a72ba",
  border: "none",

  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  lineHeight: "14px",

  "@media (max-width: 600px)": {
    marginTop: "4rem",
  },
},
  

filterCardResetBtn: {
  color: "#2F7CBD",
  backgroundColor: "#fff",
  fontSize: "0.875rem",
  border: " 1px solid #2F7CBD",
  borderRadius: 10,
  width: 90,
  height: 40,
  textTransform: "capitalize",
  // marginTop: "13%",
},

filterCardApplyBtn: {
  color: "#fff",
  backgroundColor: "#2F7CBD",
  fontSize: "0.875rem",
  border: " 1px solid #2F7CBD",
  borderRadius: 10,
  width: 90,
  height: 40,
  textTransform: "capitalize",
  "&:hover": {
    backgroundColor: "#2F7CBD",
  },
},
filterBtnGrid: {
  "@media (min-width: 600px)": {
    textAlign: "right",
  },
  "@media (max-width: 600px)": {
    padding: 10,
  },
},filterBtn: {
  marginLeft: 0,
  marginTop: 0,
  height: "35px",
  display: "flex",
  alignItems: "center",
},
filterCardDiv: {
  overflowX: "auto",
},
filterCard: {
  boxShadow: " 10px 10px 10px #00000029 !important",
  border: " 1px solid #707070",
  borderRadius: "20px !important",
  width: "100%",
  zIndex: 100,
  marginTop: "2%",
},
filterCardGridContainer: {
  padding: 15,
  height: "100%",
},
filterCardGrid: {
  borderRight: "1px solid #707070",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  "@media (max-width: 600px)": {
    border: "none",
  },
},
filterCardHeadText: {
  fontWeight: "bold",
  fontSize: "1rem",
},
filterCardSubHeadText: {
  fontSize: 24,
},
filterCardInput: {
  borderRadius: 10,
  width: "100%",
},
filterCardBtnGrid: {
  textAlign: "center",
  alignSelf: "center",
},

  // CSVlink: {
  //   display: "none",
  // },
}))
  